import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {ImageCategoryTypes} from '../../../models/questions/shared/imageType.model';

@Injectable({
  providedIn: 'root'
})
export class EvoImageSelectorService {

  isVisible = false;
  category: string;
  imagesToExclude: string[] = [];
  subscriber: Subscriber<string>;

  constructor() { }

  show(category: string = ImageCategoryTypes.monsters, imagesToExclude: string[] = []): Observable<string> {

    this.isVisible = true;
    this.imagesToExclude = imagesToExclude;
    this.category = category;

    return new Observable((subscriber) => {
      this.subscriber = subscriber;
    });
  }

  onImageSelected(img: string) {

    if (this.subscriber) {
      this.subscriber.next(img);
      this.subscriber.complete();
    }

    this.hide();

  }

  hide() {
    this.isVisible = false;
    this.imagesToExclude = [];
  }

}
